import { IconeCopiar } from "components/IconeCopiar";

interface Props {
  chassi: string;
}

export function CopiarChassi({ chassi }: Props) {
  return (
    <div>
      {
        <IconeCopiar
          texto={chassi}
          mensagem="Copiar chassi"
          widthCell={600}
          maxWidthTexto={200}
          tooltipRight={-17}
          tooltipWidth={147}
          tooltipBottom={4}
        />
      }
    </div>
  );
}
